import { createContext } from "react";
import type { AppUser, Role } from "./types";

export interface AuthContextValue {
  user: AppUser | null;
  loading: boolean;
  /** Real flow uses Supabase Auth; dev/mock flow accepts a role to preview portals. */
  signIn: (email: string, password: string, devRole?: Role) => Promise<void>;
  signOut: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextValue | undefined>(undefined);
